import { useState } from "react";
import { LifeBuoy, ChevronDown, ChevronRight } from "lucide-react";

const STAPPEN = [
  { t: "De app laadt niets / alle cijfers staan op 0 / 'Verversen mislukt'", s: [
    "Klik hierboven op 'Laadtest (stap voor stap)'. Staat elke stap op ✓ met normale tijden? Dan is het een verbindings- of browserprobleem: herlaad de pagina (F5) of log uit en weer in.",
    "Staat een stap op ✕? Lees de fout. Klik dan 'Zelfcontrole uitvoeren' (plant de migratie opnieuw in) en daarna 'Pagina herladen'.",
    "Nog steeds leeg? Beheer → Back-ups → bij de nieuwste back-up 'Terugzetten'. Dit zet alle gegevens terug naar dat moment (er wordt eerst automatisch een back-up van nu gemaakt).",
    "Helpt dat niet: stuur de tekst uit de Laadtest door. Uw gegevens zijn niet weg; het gaat dan om het laden, niet om de opslag.",
  ] },
  { t: "Een getal, regel of instelling is verdwenen of staat op een oude waarde", s: [
    "Productieregel / inboeking / medewerker / afwezigheid verwijderd? → 'Prullenbak records' (of Stamgegevens → Prullenbak, of in de afwezigheid-modal 'Prullenbak tonen') → Terugzetten.",
    "Verkeerde waarde in een regel? → 'Wijzigingshistorie per record': zoek de regel, open Historie, kies de juiste versie → 'Deze versie terugzetten'.",
    "Kosteninstellingen of directiecijfers kloppen niet? → 'Gericht terugzetten': kies een herstelpunt met het juiste uurtarief/aantal maanden → 'Kosten' of 'Directie'. Al het andere blijft staan.",
    "Planning-uren van een week kwijt? → Personeelsplanning → knop 'Historie' bij de medewerker → versie terugzetten.",
  ] },
  { t: "Melding 'Opslaan geblokkeerd ter bescherming'", s: [
    "Dit is geen fout: de server weigerde een opslag die gevulde gegevens zou leegmaken of in één keer veel zou wijzigen. Er is niets overschreven.",
    "Klik 'Cloudversie laden' en voer uw laatste wijziging opnieuw in. Beheer heeft automatisch een mail met de details gekregen.",
  ] },
  { t: "Melding 'Gelijktijdige bewerking' (collega heeft gewijzigd)", s: [
    "Kies 'Hun versie laden' om de nieuwste cloudversie te zien en uw wijziging daarna opnieuw te doen (veiligste keuze).",
    "Komt dit steeds terug terwijl u alleen werkt? Herlaad de pagina en controleer bij 'App-versies' of iedereen op de nieuwste versie zit.",
  ] },
  { t: "Kiosk/klok toont geen medewerkers of iemand kan niet klokken", s: [
    "Stamgegevens → Personeel: staat de medewerker erin met vinkje 'klok'? Zo niet: Prullenbak → Herstel.",
    "Controleer de pincode bij de medewerker en herlaad het kiosk-scherm.",
  ] },
  { t: "Collega ziet oude schermen / mist nieuwe knoppen", s: [
    "Beheer → App-versies: staat de collega op een oude versie? Laat hem/haar de pagina volledig herladen (Ctrl+F5) of de PWA sluiten en opnieuw openen.",
  ] },
  { t: "Iemand kan niet inloggen", s: [
    "Gebruikersbeheer → controleer e-mail, rol en 'actief'. Zet eventueel een nieuw wachtwoord.",
    "Melding over opslagruimte in de browser? Laat de collega uitloggen, browsergegevens van deze site wissen en opnieuw inloggen.",
  ] },
  { t: "Wanneer wél hulp vragen", s: [
    "Als de Laadtest een ✕ toont die na Zelfcontrole + herladen blijft, of als een back-up terugzetten niet lukt. Stuur dan de tekst van de Laadtest mee — dat scheelt zoektijd en kosten.",
  ] },
];

export function HulpStappen() {
  const [open, setOpen] = useState(null);
  return (
    <div className="mb-8 rounded-lg border border-slate-200 bg-white p-5" data-testid="hulp-stappen">
      <h2 className="text-lg font-bold text-slate-900 flex items-center gap-2 mb-1"><LifeBuoy className="h-5 w-5 text-[#1C64B0]" />Zelf oplossen: stappenplannen</h2>
      <p className="text-sm text-slate-500 mb-3">Loop bij een probleem eerst deze stappen door. Alles hieronder kunt u als beheerder zelf, zonder hulp van buitenaf.</p>
      {STAPPEN.map((b, i) => (
        <div key={i} className="border-t border-slate-100">
          <button data-testid={`hulp-${i}`} onClick={() => setOpen(open === i ? null : i)} className="flex w-full items-center gap-2 py-2 text-left text-sm font-semibold text-slate-800 hover:text-[#1C64B0]">{open === i ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}{b.t}</button>
          {open === i && <ol className="mb-3 ml-7 list-decimal space-y-1 text-sm text-slate-600">{b.s.map((x, j) => <li key={j}>{x}</li>)}</ol>}
        </div>
      ))}
    </div>
  );
}
